export const productsReducer = (action, setProductsState) => {
  
  switch (action.type) {
  case 'ADD':
    setProductsState((current) => {
      return [
        ...current,
        {
          id: _getIndex(current),
          ...action.payload,
        },
      ];
    });
    break;
  case 'DELETE':
    setProductsState((current) => {
      return current.filter((item)=>item.id!==action.payload.id)
    });
    break;
  case 'UPDATE':
    setProductsState((current) => {
      return current.map((item)=>{
        if(item.id===action.payload.id){
          return {
            ...item,
            [action.payload.key]: {
              ...action.payload.newValue
            }
          }
        }
        else{
          return item;
        }
      })
    })
    break;
  case 'DELETE_BY_PRODUCT_GROUP':
    setProductsState((current) => {
      return current.filter((item)=>item.productGroup.value!==action.payload.productGroup)
    });
    break;
  case 'DELETE_ALL_PRODUCTS':
    setProductsState([]);
    break;
  default:
    return;
  }
};

export const _getIndex = (current) => {
  return current.length === 0 ? 1 : current[current.length - 1].id + 1;
};